////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, map, isUndefined } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const initKioskCreationAddItems = {
	[ActionsTypes.POST_KIOSK_ADD_ITEMS]: (state) =>
		update(state, {
			columns: {
				isEditingTrigger: {
					$set: false,
				},
				isSearchfieldUpdated: {
					$set: false,
				},
			},
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				addItems: {
					data: {
						headerContent: {
							contentPagined: {
								content: {
									$set: [],
								},
							},
						},
					},
					isUpdated: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.POST_KIOSK_ADD_ITEMS_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				addItems: {
					data: {
						$set: payload.data,
					},
					errorUnlink: {
						$set: {},
					},
				},
				statusId: {
					$set: payload.data.headerParam.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_ADD_ITEMS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_LINK_ITEMS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				addItems: {
					isUpdated: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_LINK_ITEMS_SUCCESS]: (state, payload) => {
		let itemsList = cloneDeep(state.initKioskCreation.addItems.data)
		itemsList.headerContent.contentPagined.content = map(itemsList.headerContent.contentPagined.content, (elem) => {
			if (elem.itemId === payload?.data?.line?.itemId) {
				elem = payload.data.line
			}
			return elem
		})
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				addItems: {
					data: {
						$set: itemsList,
					},
					isUpdated: {
						$set: true,
					},
				},
				statusId: {
					$set: payload?.data?.progressInfo?.statusId,
				},
			},
		})
	},
	[ActionsTypes.PUT_KIOSK_LINK_ITEMS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_UNLINK_ITEMS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				addItems: {
					isUpdated: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.PUT_KIOSK_UNLINK_ITEMS_SUCCESS]: (state, payload) => {
		let itemsList = cloneDeep(state.initKioskCreation.addItems.data)
		itemsList.headerContent.contentPagined.content = map(itemsList.headerContent.contentPagined.content, (elem) => {
			if (elem.itemId === payload?.data?.line?.itemId) {
				elem = payload.data.line
			}
			return elem
		})
		let errorUnlinkCp = cloneDeep(state.initKioskCreation.addItems.errorUnlink)
		if (!isUndefined(payload.data.errorCode)) {
			errorUnlinkCp = payload.data
		}

		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				addItems: {
					data: {
						$set: itemsList,
					},
					isUpdated: {
						$set: true,
					},
					errorUnlink: {
						$set: errorUnlinkCp,
					},
				},
				statusId: {
					$set: payload.data?.progressInfo?.statusId,
				},
			},
		})
	},
	[ActionsTypes.PUT_KIOSK_UNLINK_ITEMS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_ITEMS_VALIDATE]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_ITEMS_VALIDATE_SUCCESS]: (state, payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				statusId: {
					$set: payload.data.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_ITEMS_VALIDATE_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_DATA_ADD_ITEMS]: (state, _payload) =>
		update(state, {
			initKioskCreation: {
				statusId: {
					$set: 0,
				},
				requestId: {
					$set: null,
				},
				availableOptions: {
					$set: {},
				},
				addItems: {
					data: {
						$set: {
							headerContent: {
								contentPagined: {
									content: [],
								},
							},
						},
					},
				},
				forceReadOnly: {
					$set: false,
				},
			},
		}),
}

export default initKioskCreationAddItems
